import { all, put, call, fork, take } from "redux-saga/effects";
import * as api from "../../utils/api";
import {
  touchPointActions,
  ADD_TOUCHPOINT_REQUEST,
  UPDATE_TOUCHPOINT_REQUEST,
  GET_TOUCHPOINTS_REQUEST,
  GET_AUDIT_TOUCHPOINTS_REQUEST,
  GET_TOUCHPOINT_REQUEST,
  LIKE_TOUCHPOINT_REQUEST,
  FAVOR_TOUCHPOINT_REQUEST,
  DELETE_TOUCHPOINT_REQUEST,
  ADD_TOUCHPOINT_COMMENT_REQUEST,
  DELETE_TOUCHPOINT_COMMENT_REQUEST,
  LIKE_TOUCHPOINT_COMMENT_REQUEST,
  EDIT_TOUCHPOINT_COMMENT_REQUEST,
} from "./actions";

export function* asyncAddTouchPoint({ payload, resolve, reject }) {
  try {
    const response = yield call(api.addTouchPoint, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.addTouchPointSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchAddTouchPoint() {
  while (true) {
    const action = yield take(ADD_TOUCHPOINT_REQUEST);
    yield* asyncAddTouchPoint(action);
  }
}

export function* asyncUpdateTouchPoint({ payload, resolve, reject }) {
  try {
    const response = yield call(api.updateTouchPoint, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.updateTouchPointSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchUpdateTouchPoint() {
  while (true) {
    const action = yield take(UPDATE_TOUCHPOINT_REQUEST);
    yield* asyncUpdateTouchPoint(action);
  }
}

export function* asyncGetTouchPoints({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getTouchPoints, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.getTouchPointsSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetTouchPoints() {
  while (true) {
    const action = yield take(GET_TOUCHPOINTS_REQUEST);
    yield* asyncGetTouchPoints(action);
  }
}

export function* asyncGetAuditTouchPoints({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getUserAudits, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.getAuditTouchPointsSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetAuditTouchPoints() {
  while (true) {
    const action = yield take(GET_AUDIT_TOUCHPOINTS_REQUEST);
    yield* asyncGetAuditTouchPoints(action);
  }
}

export function* asyncGetTouchPoint({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getTouchPoint, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.getTouchPointSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetTouchPoint() {
  while (true) {
    const action = yield take(GET_TOUCHPOINT_REQUEST);
    yield* asyncGetTouchPoint(action);
  }
}

export function* asyncLikeTouchPoint({ payload, resolve, reject }) {
  try {
    const response = yield call(api.likeTouchPoint, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.likeTouchPointSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchLikeTouchPoint() {
  while (true) {
    const action = yield take(LIKE_TOUCHPOINT_REQUEST);
    yield* asyncLikeTouchPoint(action);
  }
}

export function* asyncFavorTouchPoint({ payload, resolve, reject }) {
  try {
    const response = yield call(api.favorTouchPoint, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.favorTouchPointSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchFavorTouchPoint() {
  while (true) {
    const action = yield take(FAVOR_TOUCHPOINT_REQUEST);
    yield* asyncFavorTouchPoint(action);
  }
}

export function* asyncDeleteTouchPoint({ payload, resolve, reject }) {
  try {
    const response = yield call(api.deleteTouchPoint, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.deleteTouchPointSuccess());
    }
    resolve();
  } catch (err) {
    reject(err);
  }
}

export function* watchDeleteTouchPoint() {
  while (true) {
    const action = yield take(DELETE_TOUCHPOINT_REQUEST);
    yield* asyncDeleteTouchPoint(action);
  }
}

export function* asyncAddTouchPointComment({ payload, resolve, reject }) {
  try {
    const response = yield call(api.addTouchPointComment, payload);
    if (response.status === 200 && response.data.commentList) {
      yield put(touchPointActions.addTouchPointCommentSuccess(response.data.commentList));
    }
    resolve();
  } catch (err) {
    reject(err);
  }
}

export function* asyncEditTouchPointComment({ payload, resolve, reject }) {
  try {
    const response = yield call(api.editTouchPointComment, payload);
    if (response.status === 200 && response.data.commentList) {
      yield put(touchPointActions.editTouchPointCommentSuccess(response.data.commentList));
    }
    resolve();
  } catch (err) {
    reject(err);
  }
}

export function* watchTouchPointComment() {
  while (true) {
    const action = yield take(ADD_TOUCHPOINT_COMMENT_REQUEST);
    yield* asyncAddTouchPointComment(action);
  }
}

export function* watchTouchPointCommentEdit() {
  while (true) {
    const action = yield take(EDIT_TOUCHPOINT_COMMENT_REQUEST);
    yield* asyncEditTouchPointComment(action);
  }
}

export function* asyncDeleteTouchPointComment({ payload, resolve, reject }) {
  try {
    const response = yield call(api.deleteTouchPointComment, payload);
    if (response.status === 200 && response.data) {
      yield put(touchPointActions.deleteTouchPointCommentSuccess(response.data));
    }
    resolve();
  } catch (err) {
    reject(err);
  }
}

export function* watchDeleteTouchPointComment() {
  while (true) {
    const action = yield take(DELETE_TOUCHPOINT_COMMENT_REQUEST);
    yield* asyncDeleteTouchPointComment(action);
  }
}

export function* asyncLikeTouchPointComment({ payload, resolve, reject }) {
  try {
    const response = yield call(api.likeTouchPointComment, payload);
    if (response.status === 200 && response.data) {
      response.data.commentId = payload.commentId;
      yield put(touchPointActions.likeTouchPointCommentSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchLikeTouchPointComment() {
  while (true) {
    const action = yield take(LIKE_TOUCHPOINT_COMMENT_REQUEST);
    yield* asyncLikeTouchPointComment(action);
  }
}

export default function* () {
  yield all([
    fork(watchAddTouchPoint),
    fork(watchUpdateTouchPoint),
    fork(watchGetTouchPoints),
    fork(watchGetAuditTouchPoints),
    fork(watchGetTouchPoint),
    fork(watchLikeTouchPoint),
    fork(watchFavorTouchPoint),
    fork(watchDeleteTouchPoint),
    fork(watchTouchPointComment),
    fork(watchDeleteTouchPointComment),
    fork(watchLikeTouchPointComment),
    fork(watchTouchPointCommentEdit),
  ]);
}
